<div class="campanha-cliente-view">
    <div class="card">
        <div class="card-header">
            <sgt-campanha-cliente-filter
                [idCampanha]="idCampanha"
                [filter]="filter"
                (filterChange)="onFilterChange()">
            </sgt-campanha-cliente-filter>
        </div>
 
        <div class="card-body">
            <sgt-cliente-list
                #clienteList
                idDataTable="campanhaResultadoTableClientesAquisicoes"
                visualizacaoStorageKey="campanhResultadoStorageClientesAquisicoes"
                [filter]="filter"
                [optionsVisibility]="{
                    canEdit: false,
                    canPrintFichaCadastral: true,
                    canImportOneErp_v1: false,
                    canImportOneErp: false,
                    canInsertNegocio: false,
                    canIniciarAnaliseFinanceira: false,
                    canCancelarIniciarAnaliseFinanceira: false,
                    canConcluirAnaliseFinanceira: false,
                    canCancelarConcluirAnaliseFinanceira: false,
                    canRevisarAnaliseFinanceira: false,
                    canCongelar: false,
                    canDescongelar: false,
                    canPreBaixar: false,
                    canEditPreBaixa: false,
                    canCancelarPreBaixa: false,
                    canBaixar: false,
                    canEditBaixa: false,
                    canCancelarBaixa: false                 
                }">
            </sgt-cliente-list>
        </div>
    </div>
</div>
